import { API, graphqlOperation } from "aws-amplify";
import { useContext, useState } from "react";
import {
  READ_CONFIGS,
  CREATE_CONFIG,
  DELETE_CONFIG,
  UPDATE_CONFIG,
  RESET_CURRENT,
  updateRedmine,
} from "../actions";
import AppContext from "../contexts/AppContext";
import {
  createRedmineConfig,
  deleteRedmineConfig,
  updateRedmineConfig,
} from "../graphql/mutations";
import { listRedmineConfigs } from "../graphql/queries";

export const useConfig = () => {
  const { state, dispatch } = useContext(AppContext) || {};
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const readConfig = async () => {
    try {
      setErrors({});
      if (loading !== true) setLoading(true);

      API.graphql(graphqlOperation(listRedmineConfigs))
        .then((response) => {
          dispatch({ type: READ_CONFIGS, response });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setErrors({ api: err });
        });
      return "success";
    } catch (err) {
      setErrors({ function: err });
    }
  };

  const createConfig = async (values) => {
    try {
      setErrors({});
      if (loading !== true) setLoading(true);

      API.graphql(
        graphqlOperation(createRedmineConfig, {
          input: {
            name: values.name,
            redmineurl: values.redmineurl,
            apikey: values.apikey,
            timestamp: Date.now(),
          },
        })
      )
        .then((response) => {
          dispatch({ type: CREATE_CONFIG, response });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setErrors({ api: err });
        });
    } catch (err) {
      setErrors({ function: err });
    }
  };

  const updateConfig = async (values) => {
    try {
      setErrors({});
      if (loading !== true) setLoading(true);

      API.graphql(
        graphqlOperation(updateRedmineConfig, {
          input: {
            ...values,
            timestamp: Date.now(),
          },
        })
      )
        .then((response) => {
          dispatch({ type: UPDATE_CONFIG, response });
          if (state.current.id === response.data.updateRedmineConfig.id) {
            const { id, name, redmineurl, apikey } =
              response.data.updateRedmineConfig;
            updateRedmine(dispatch, { id, name, redmineurl, apikey });
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setErrors({ api: err });
        });
    } catch (err) {
      setErrors({ function: err });
    }
  };

  const deleteConfig = async (current, id) => {
    try {
      setErrors({});
      if (loading !== true) setLoading(true);

      API.graphql(
        graphqlOperation(deleteRedmineConfig, {
          input: { id: id },
        })
      )
        .then((response) => {
          // 削除対象のconfigがcurrentに設定されている場合はcurrentのstateを初期化する。
          const res = response.data.deleteRedmineConfig;
          const isCurrent =
            res.apikey === current.apikey &&
            res.name === current.name &&
            res.redmineurl === current.redmineurl;
          if (isCurrent) dispatch({ type: RESET_CURRENT });

          dispatch({ type: DELETE_CONFIG, response });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setErrors({ api: err });
        });
    } catch (err) {
      setErrors({ function: err });
    }
  };

  return {
    loading,
    setLoading,
    readConfig,
    createConfig,
    updateConfig,
    deleteConfig,
    errors,
  };
};
